import { Container, Typography, Box, Grid } from '@mui/material';
import StrategyDiagram from '../components/StrategyDiagram';

const StrategyPage = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      <Typography variant="h2" component="h1" gutterBottom sx={{ fontWeight: 'bold', mb: 6 }}>
        Our Investment Strategy
      </Typography>
      
      <Box sx={{ mb: 8 }}>
        <Typography variant="h4" component="h2" gutterBottom sx={{ fontWeight: 'bold', mb: 3 }}>
          What Are GP Stakes?
        </Typography>
        <Typography variant="body1" paragraph>
          GP stakes are direct investments in a general partner's management company, typically in a minority, non-strategic and non-voting capacity. Investors in GP stakes receive their share of future cash flows derived from management fees, balance sheet investments, and carried interest earned by the management company's underlying funds and investments.
        </Typography>
        <Typography variant="body1" paragraph>
          Successful GPs may be inclined to sell a minority position for a variety of financial and strategic reasons including increasing GP commitments, launching new products, expanding into new markets, providing liquidity for founders, and driving succession planning.
        </Typography>
      </Box>

      <Box sx={{ mb: 8 }}>
        <Typography variant="h4" component="h2" gutterBottom sx={{ fontWeight: 'bold', mb: 3 }}>
          Why GP Stakes?
        </Typography>
        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <Typography variant="h6" component="h3" gutterBottom>
              Attractive Business Model
            </Typography>
            <Typography variant="body1" paragraph>
              Private market sponsors benefit from strong business fundamentals with operating margins of 40%-70% and very high cash flow conversion. Management fees provide contracted revenue for a decade or longer, while carried interest offers considerable upside potential.
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography variant="h6" component="h3" gutterBottom>
              Secular Tailwinds
            </Typography>
            <Typography variant="body1" paragraph>
              Private markets AUM grew from $2.7 trillion in 2010 to $8.9 trillion in 2021 and is forecasted to reach $17.8 trillion by 2026. This growth is driven by increased institutional allocations and the untapped potential of retail investors.
            </Typography>
          </Grid>
        </Grid>
      </Box>

      <Box sx={{ mb: 8 }}>
        <Typography variant="h4" component="h2" gutterBottom sx={{ fontWeight: 'bold', mb: 3 }}>
          Our Approach
        </Typography>
        <Typography variant="body1" paragraph>
          Aquamire targets established private market managers with long track records, strong fundraising capabilities, and specialized expertise in their respective markets. We focus on firms with:
        </Typography>
        <ul>
          <li>Proven ability to generate consistent returns across market cycles</li>
          <li>Scalable platforms with potential for AUM growth</li>
          <li>Specialized investment strategies that create competitive advantages</li>
          <li>Strong alignment between management and investors</li>
        </ul>
      </Box>

      <StrategyDiagram />
    </Container>
  );
};

export default StrategyPage;
